import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($options.installmentStateComponent.name), _mergeProps({
    key: $options.installmentStateComponent.key
  }, $options.installmentStateComponent.model), null, 16 /* FULL_PROPS */))
}